<prism-dialog id="sh-notification-details-dialog-div" *transloco="let t" [visible]="true">
	<div id="sh-notification-details-content-div">
		<div id="sh-notification-details-subject-div">
			{{ notificationData.subject }}
		</div>
		<div id="sh-notification-details-content-div">
			@if (notificationData.sentAt) {
				<div>
					<div id="sh-notification-details-received-label-div" class="sh-notification-details-subheading">
						{{ t('cloud.shared.notification.received') }}
					</div>
					<p id="sh-notification-details-sent-at-p" class="sh-notification-details-subheading-content">
						{{ formatTime(timeZone, displayDateFormat, notificationData.sentAt) }}
					</p>
				</div>
			}
			<div>
				<div id="sh-notification-details-organization-label-div" class="sh-notification-details-subheading">
					{{ t('cloud.shared.notification.organization') }}
				</div>
				<p id="sh-notification-details-organization-name-p" class="sh-notification-details-subheading-content">
					{{ notificationData.organization?.name }}
				</p>
				<hr id="sh-notification-details-prism-divider" class="prism-divider" orientation="horizontal" />
			</div>
			<div>
				<div
					*ngIf="notificationData.body"
					id="sh-notification-details-body-content-div"
					[innerHTML]="notificationData.body"
				></div>
			</div>
		</div>
	</div>
	<div id="sh-notification-details-footer-buttons-slot" slot="dialog-footer-buttons">
		<prism-button (click)="closePopup()" id="sh-notification-details-close-button">
			{{ t('cloud.shared.notification.close') }}
		</prism-button>
		@if (notificationListType === messageCenterNotificationsListType.INBOX) {
			<prism-button (click)="markAsTrash(notificationData.id)" id="sh-notification-details-move-to-trash-button">
				{{ t('cloud.shared.notification.move-to-trash') }}
			</prism-button>
		}
	</div>
</prism-dialog>
